import { call, put, takeLatest } from "redux-saga/effects";
import request from "@util/net/request";
import { AxiosResponse } from "axios";
import { GET_STYLING_FILTERS, StylingFilterActions } from "@redux/reducer";
import {
  CategoryFilterUgcData,
  CategoryFilterUgcResponse,
  CoordinateFilterUgcData,
  CoordinateFilterUgcResponse,
  DepartmentIdEnum,
  FiltersPayload,
  FiltersResponseType
} from "@type/index";
import {
  GET_STYLING_FILTERS_CATEGOTY,
  GET_STYLING_FILTERS_COORDINATE
} from "@redux/reducer/filters";
import {
  CategoryFilterMapper,
  CoordinateFilterMapper
} from "@util/net/queryParameters";
import { handleGetGenderCode } from "@util/helpers";

export function* getStylingFiltersSaga(action: { payload: FiltersPayload }) {
  try {
    const payload: FiltersPayload = action.payload;
    yield put(StylingFilterActions.getStylingFiltersLoading(true));
    if (action.payload.type === "sb") {
      yield put(StylingFilterActions.getStylingFiltersCategory(payload));
      yield put(StylingFilterActions.getStylingFiltersCoordinate(payload));
    } else {
      yield put(StylingFilterActions.getStylingFiltersCategory(payload));
    }
  } catch (error) {
    yield put(StylingFilterActions.getStylingFiltersLoading(false));
  }
}

export function* getStylingFiltersCategorySaga(action: {
  payload: FiltersPayload;
}) {
  try {
    const payload: FiltersPayload = action.payload;
    yield put(StylingFilterActions.getStylingFiltersCategoryLoading(true));
    const res: AxiosResponse<CategoryFilterUgcResponse> = yield call(
      request.get,
      "/style-categories",
      {
        params: {
          root_id: payload.rootId
        }
      }
    );
    const arr = res.data.result.style_categories || [];
    let _arr: Array<CategoryFilterUgcData> = [];
    if (arr.length > 0) {
      _arr = arr.filter((item: CategoryFilterUgcData) =>
        payload.departmentId?.includes(
          handleGetGenderCode(item.name as DepartmentIdEnum).toString()
        )
      );
    }
    let categories: Array<CategoryFilterUgcData> = [];
    if (_arr.length > 0) {
      _arr.map((a) => {
        if (a.style_categories) {
          categories = [...categories, ...a.style_categories];
        }
        return categories;
      });
    }
    const _res: FiltersResponseType = {
      styleCategories:
        categories.length > 0 ? [...CategoryFilterMapper(categories)] : []
    };
    yield put(StylingFilterActions.getStylingFiltersSuccess(_res));
  } catch (error) {
    yield put(StylingFilterActions.getStylingFiltersCategoryLoading(false));
  }
}

export function* getStylingFiltersCoordinateSaga(action: {
  payload: FiltersPayload;
}) {
  try {
    const payload: FiltersPayload = action.payload;
    yield put(StylingFilterActions.getStylingFiltersCoordinateLoading(true));
    const res: AxiosResponse<CoordinateFilterUgcResponse> = yield call(
      request.get,
      "/official/tags",
      {
        params: {
          gender_id: payload.departmentId,
          content_language: payload.contentLanguage
        }
      }
    );
    const arr = res.data.result.tag_categories || [];
    let _arr: Array<CoordinateFilterUgcData> = [];
    if (arr.length > 0) {
      _arr = arr.filter(
        (item: CoordinateFilterUgcData) =>
          item.category_code === "StylingCategory"
      );
    }
    const _res: FiltersResponseType = {
      tagCategories:
        _arr.length > 0 && _arr[0].tags
          ? [...CoordinateFilterMapper(_arr[0].tags)]
          : []
    };
    yield put(StylingFilterActions.getStylingFiltersSuccess(_res));
  } catch (error) {
    yield put(StylingFilterActions.getStylingFiltersCoordinateLoading(false));
  }
}

export function* watchLoadStylingFiltersSaga() {
  yield takeLatest<any>(GET_STYLING_FILTERS, getStylingFiltersSaga);
  yield takeLatest<any>(
    GET_STYLING_FILTERS_CATEGOTY,
    getStylingFiltersCategorySaga
  );
  yield takeLatest<any>(
    GET_STYLING_FILTERS_COORDINATE,
    getStylingFiltersCoordinateSaga
  );
}
